import React from "react";
import styled from "styled-components";
import { List } from "react-content-loader";

const Loading = () => {
  return (
    <Styled>
      <List backgroundColor="#BDBDBD" foregroundColor="#BDBDBD" />
    </Styled>
  );
};

const Styled = styled.div`
  padding: 4rem;
`;

export default Loading;
